import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './modules/extranet/guards/auth.guard';
import { LoginGuard } from './modules/extranet/guards/login.guard';
import { ExtranetComponent } from './modules/extranet/extranet.component';
import { ResetPasswordGuard } from './modules/extranet/guards/reset-password.guard';

const routes: Routes = [
  { path: '', redirectTo: 'extranet', pathMatch: 'full' },
  {
    path: 'extranet',
    canActivate: [AuthGuard, ResetPasswordGuard],
    component: ExtranetComponent,
    loadChildren: () =>
      import('./modules/extranet/extranet.module').then(
        (m) => m.ExtranetModule
      ),
  },
  {
    path: 'auth',
    canActivate: [LoginGuard],
    loadChildren: () =>
      import('./modules/extranet/auth/auth.module').then((m) => m.AuthModule),
  },
  { path: '**', pathMatch: 'full', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
